export function validateField(fieldValue = "", fieldType = "", toast = null) {
    const value = String(fieldValue || "").trim();
    const type = String(fieldType || "").toLowerCase();

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobilePattern = /^[0-9]{7,15}$/;
    const minLength = 4;
    const domainRegex = /^(?!-)(?:[a-zA-Z0-9-]{1,63}\.)+[A-Za-z]{2,}$/;
    // If field is empty — fail
    if (!value) {
        if (toast) toast.warning("This field is required");
        return false;
    }

    switch (type) {
        case "email":

            if (!emailPattern.test(value)) {
                if (toast) toast.warning("Enter valid email");
                return false;
            }
            break;

        case "mobile":

            if (!mobilePattern.test(value)) {
                if (toast) toast.warning("Enter valid mobile number");
                return false;
            }
            break;

        case "number":
            if (isNaN(value) || Number(value) <= 0) {
                if (toast) toast.warning("Enter valid number greater than zero");
                return false;
            }
            break;

        case "password":


            if (value.length < minLength) {
                toast && toast.warning(`Password must be at least ${minLength} characters`);
                return false;
            }
            break;
            
        case "domain": {

            if (!domainRegex.test(value)) {
                toast && toast.warning("Enter valid domain or subdomain (example: app.company.com)");
                return false;
            }
            break;
        }

        default:
            // If fieldType unknown, treat as text only
            if (value.length < 2) {
                if (toast) toast.warning("Invalid or too short value");
                return false;
            }
    }

    return true;
}
